import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'src/components/Svg';
import Styled from './Header.styles';
import styles from './styles.css';

const Header = ({ className }) => (
  <Styled.Header className={className}>
    <Svg className={styles.logo} name="eiq-assess-lrqa-logo" />
  </Styled.Header>
);

Header.propTypes = {
  className: PropTypes.string,
};

Header.defaultProps = {
  className: null,
};

export default React.memo(Header);
